





































import Vue from 'vue';
import { BDropdown, BDropdownItemButton, VBTooltip } from 'bootstrap-vue';

export default Vue.extend({
  name: 'ActionsCellPresenter',
  components: {
    BDropdown,
    BDropdownItemButton,
  },
  directives: {
    BTooltip: VBTooltip,
  },
  computed: {
    hasActions(): boolean {
      return Object.keys(this.$attrs.data).length > 0;
    },
  },
  methods: {
    onActionClick(key, objectId) {
      this.$emit('actionClick', key, objectId);
    },
  },
});
